import { jwtDecode } from 'jwt-decode';

export const checkIsTokenValid = (accessToken?: string | null) => {
  if (!accessToken) return false;
  const expireTime = jwtDecode(accessToken).exp;
  if (!expireTime) return false;
  const currentTime = Date.now() / 1000;
  return expireTime > currentTime + ONE_DAY_IN_SECONDS;
};

const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
